/**
 * Parse a query string into a plain object.
 *
 * @param {string} input query string, without a leading '?'
 * @return {Object} map of key -> string value, or key -> string[] for
 *   repeated keys
 */
export function parse(input = '') {
  const params = new URLSearchParams(input);
  const result = {};

  params.forEach((value, key) => {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return result;
}

/**
 * Serialize an object into a query string using '&' between pairs and '='
 * between keys and values, matching querystring.stringify.
 *
 * Uses encodeURIComponent rather than URLSearchParams for value/key encoding:
 * URLSearchParams percent-encodes characters that querystring leaves intact
 * (e.g. ~ ! ' ( )) and encodes spaces as '+', which would change generated
 * URL output. encodeURIComponent matches querystring.escape byte-for-byte
 * (spaces -> %20, unreserved chars preserved).
 *
 * @param {Object} obj object to serialize
 * @return {string} the encoded query string (no leading '?')
 */
export function stringify(obj = {}) {
  const pairs = [];

  const append = (key, value) => {
    const encodedValue = value == null ? '' : encodeURIComponent(String(value));

    pairs.push(`${encodeURIComponent(key)}=${encodedValue}`);
  };

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (Array.isArray(value)) {
      value.forEach((item) => append(key, item));
    } else {
      append(key, value);
    }
  });

  return pairs.join('&');
}
